import { authenticatedApiInstance } from '../client'

export const getUserIntercomHash = async ({ token }: { token: string }): Promise<string> =>
  authenticatedApiInstance(token)
    .get('/user/me/intercom-hash')
    .then((res) => res.data.data)
